import countries from './utils/countries'
import TableActions from './components/ivu-table/table-actions.vue'

export function fetchCountries(defaultCountry) {
   return new Promise(async (resolve, reject) => {
      try {
         global.global_forms = {}
         global.TableActions = TableActions

         resolve(countries)
      } catch (error) {
         reject(error)
      }
   });
}